import React from 'react';
import { Skeleton, Box } from '@mui/material';

interface SkeletonLoaderProps {
  variant?: 'text' | 'rectangular' | 'circular' | 'rounded';
  width?: number | string;
  height?: number | string;
  animation?: 'pulse' | 'wave' | false;
  count?: number; // Number of skeleton items
  style?: React.CSSProperties; // Additional custom styles
}

const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({
  variant = 'text',
  width = '100%',
  height = 24,
  animation = 'wave',
  count = 1,
  style,
}) => {
  return (
    <Box>
      {Array.from({ length: count }).map((_, index) => (
        <Skeleton
          key={index}
          variant={variant}
          width={width}
          height={height}
          animation={animation}
          sx={style}
        />
      ))}
    </Box>
  );
};

export default SkeletonLoader;
